module.exports = __webpack_public_path__ + "img/login_img01.56355d55.png";